module.exports = __webpack_public_path__ + "img/C03TechRiteofDamara_ua.0bcff636.webp";